import _Promise from 'babel-runtime/core-js/promise';
import { jsonResponse } from 'fetch-utilities';

/*
  view.js
  ------------------------------------------------------------

  Load data by URL and assign the proper type to the
  application state depending on what we get back
*/

var PENDING = "store/view/PENDING";
var HINT = "store/view/HINT";
var LOADING = "store/view/LOADING";
var VIEW_LOADED = "store/view/LOADED";

var initialState = {
  state: PENDING,
  type: null,
  hintedUrl: null,
  pathname: null,
  redirect: null
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOADING:
      return {
        state: LOADING,
        // Preserve type since we might not have navigated yet, hints should have been
        // done before this.
        type: state.type,
        hintedUrl: state.hintedUrl,
        pathname: action.pathname,
        redirect: null
      };

    case HINT:
      return {
        state: LOADING,
        type: action.hintType,
        hintedUrl: action.hintUrl,
        pathname: null,
        redirect: null
      };

    case VIEW_LOADED:
      if (action.error) {
        return {
          state: VIEW_LOADED,
          type: "error",
          hintedUrl: null,
          pathname: action.pathname,
          redirect: null
        };
      }

      return {
        state: VIEW_LOADED,
        type: action.payload.type,
        hintedUrl: state.hintedUrl,
        pathname: action.pathname,
        redirect: action.payload.redirect
      };

    default:
      return state;
  }
}

/**
 * Hints of an upcoming navigation-event with data.
 *
 * The `url` is expected to be the last segment of the URL being hinted (excluding leading).
 */
var hint = function hint(type, url, data) {
  return {
    type: HINT,
    hintUrl: url,
    hintType: type,
    hintData: data
  };
};

var loadView = function loadView(url) {
  return function (dispatch, getState, client) {
    // Normalize
    url = url[0] === "/" ? url : "/" + url;

    var pathname = url.split("?")[0];

    // TODO: Check if we have a cache and use that
    dispatch({
      type: LOADING,
      url: url,
      pathname: pathname
    });

    dispatch({
      type: VIEW_LOADED,
      payload: client("/route" + url).then(jsonResponse).catch(function (err) {
        return err && err.httpStatus === 404 && { type: "404" } || _Promise.reject(err);
      }),
      url: url,
      pathname: pathname
    });
  };
};

export { PENDING, HINT, LOADING, VIEW_LOADED, hint, loadView };
export default reducer;
